var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2White(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 982.69 245.67",
    style: {
      enableBackground: "new 0 0 982.69 245.67"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.59,182.44h-2.17l-8.67,8.67l-4.34,2.17h-6.51l-2.17-2.17v-15.18l6.51-6.51v-4.34 c-8.67-13.01-13.01-28.19-13.01-47.71c0-49.88,30.36-78.07,75.9-78.07c19.52,0,32.53,4.34,45.54,13.01h2.17l8.67-8.67l4.34-2.17 h6.51l2.17,2.17v15.18l-6.51,6.51v4.34c8.68,13.01,13.01,28.19,13.01,47.71c0,49.88-30.36,78.07-75.9,78.07 C116.61,195.45,103.6,191.12,90.59,182.44z M157.82,80.52v-2.17c-6.51-4.34-13.01-6.51-21.68-6.51 c-23.85,0-36.87,15.18-36.87,45.54c0,4.34,0,10.84,2.17,19.52h2.17L157.82,80.52z M114.45,154.25v2.17 c6.51,4.34,13.01,6.51,21.69,6.51c23.85,0,36.87-15.18,36.87-45.54c0-4.34,0-10.84-2.17-19.52h-2.17L114.45,154.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.02,137.99h-36.87l-2.17,2.17v52.05l-2.17,2.17h-34.7l-2.17-2.17V44.74l2.17-2.17h75.9 c32.53,0,54.21,17.35,54.21,47.71C459.23,120.64,437.55,137.99,405.02,137.99z M405.02,75.1h-36.87l-2.17,2.17v26.02l2.17,2.17 h36.87c8.68,0,15.18-2.17,15.18-15.18S413.7,75.1,405.02,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M697.83,135.82c0,39.04-23.85,60.72-65.06,60.72c-41.2,0-65.05-21.68-65.05-60.72V44.74l2.17-2.17h34.7 l2.17,2.17v91.08c0,21.69,8.67,28.19,26.02,28.19c17.35,0,26.02-6.51,26.02-28.19V44.74l2.17-2.17h34.7l2.17,2.17V135.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M883.78,135.82l-15.18-2.17c-45.54-6.51-54.21-28.19-54.21-49.87c0-23.86,19.52-43.37,62.89-43.37 c39.03,0,62.89,15.18,62.89,45.54L938,88.11h-34.7l-2.17-2.17c0-8.67-6.51-15.18-23.85-15.18c-17.35,0-26.02,4.34-26.02,13.01 s8.67,10.84,23.85,13.01l15.18,2.17c45.54,6.51,54.21,26.02,54.21,49.88c0,23.85-17.35,47.71-65.06,47.71 c-43.37,0-67.23-17.35-67.23-49.87l2.17-2.17h34.7l2.17,2.17c0,13.01,8.67,19.52,28.19,19.52c17.35,0,28.19-4.34,28.19-15.18 C907.64,140.15,898.96,137.99,883.78,135.82z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2White);
export default __webpack_public_path__ + "static/media/logo_2_white.3ce782203a25860d541cba2dbd0fe2bb.svg";
export { ForwardRef as ReactComponent };